import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { TeaserBoxData } from '../../../shared/teaser-box/teaser-box.component'
import { ConvertedComponentData, Image } from '../../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TeaserBoxIconConverter extends CmsConverterService<TeaserBoxIconData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_title_text?.value ?? ''
    const link = formData?.st_link ?? defaultLinkData
    const altText = formData?.st_alt_text?.value ?? ''
    const lazyLoad = true
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      teaserBoxData: {
        link,
        description: formData.st_description ?? defaultTextInput,
        headline: formData.st_headline ?? defaultTextInput,
        label: formData.st_label ?? defaultTextInput,
        sticker: formData?.st_highlighting?.value?.identifier ?? '',
        backgroundColor: 'bg-' + (formData?.st_backgroundcolor?.value?.identifier ?? 'grey'),
        promotionTracking: formData.st_promotion_tracking?.value?.identifier ?? false
      },
    }
  }
}

export const TEASER_BOX_ICON_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBoxIconData>>('TeaserBoxIconConverter')

export interface TeaserBoxIconData extends ConvertedComponentData {
  teaserBoxData: TeaserBoxData;
  fsCatalogIndex?: number;
  image: Image;
}
